<template>
    <div class="page" ref="scroller">
        <header class="top-header">
            <van-search
                class="search"
                v-model="search"
                placeholder="请输入搜索关键词"
                @click.prevent="goSearch()"
            />
            <div class="markBox" @click="goZanneixinList()">
                <img class="znx-logo" src="~@/assets/znx-logo.png" alt="" />
                <span class="mark" v-if="newLetterNum">
                    <span>{{ newLetterNum }}</span>
                </span>
            </div>
        </header>
        <div class="swipeBox">
            <van-swipe class="my-swipe" autoplay="3000" indicator-color="white">
                <van-swipe-item class="item" v-for="item in ad" :key="item.id">
                    <!-- <img :src="item.image" alt="" /> -->
                    <div
                        @click="adGo(item.link)"
                        class="imgBox"
                        :style="{
                            background:
                                'url(' +
                                item.image +
                                ') no-repeat top center/cover',
                        }"
                    ></div>
                </van-swipe-item>
            </van-swipe>
        </div>
        <div class="collegeBox">
            <div class="box" v-if="ganhuo.length > 0">
                <div class="title-box">
                    <div class="title">
                        <img
                            class="ganhuo-logo"
                            src="~@/assets/ganhuo-logo.png"
                            alt=""
                        />
                        <span>极简投研日记</span>
                    </div>
                    <div>
                        <div class="footer" @click="goGanhuoList()">
                            查看更多
                        </div>
                    </div>
                </div>
                <div class="list">
                    <div
                        class="item"
                        v-for="item in ganhuo"
                        :key="item.id"
                        @click="goGanhuoDetail(item.id)"
                    >
                        <div class="top">
                            <div
                                class="free"
                                :class="[
                                    item.target == 'FREE' ? 'free' : 'pay',
                                ]"
                            >
                                <span>{{
                                    item.target == "FREE"
                                        ? "免费阅读"
                                        : item.target == "STUDENT"
                                        ? "学员专享"
                                        : item.target == "PAY"
                                        ? "付费解锁"
                                        : ""
                                }}</span>
                            </div>
                            <div class="article-title">
                                {{ item.title }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="zhuanqu gushiBox" v-for="item in zhuanqu" :key="item.id">
            <div class="title">
                <img class="gushi-logo" src="~@/assets/gushi-logo.png" alt="" />
                <span>{{ item.title }}</span>
            </div>
            <div class="list">
                <div
                    class="item"
                    v-for="study in item.studys"
                    :key="study.id"
                    @click="go(study)"
                >
                    <div class="left">
                        <div
                            class="imgBox"
                            :style="{
                                background:
                                    'url(' +
                                    study.adImg +
                                    ') no-repeat center/100% 100%',
                            }"
                        ></div>
                        <div
                            :class="{ active: study.seckillLastDay }"
                            class="activity-time-notice-box"
                        >
                            <img
                                class="activity-time-notice"
                                src="~@/assets/activity-time-notice.png"
                                alt=""
                            />
                            <span class="notice">
                                {{ study.seckillLastDay }}
                            </span>
                        </div>
                    </div>
                    <div class="right">
                        <div class="sub-title">{{ study.title }}</div>
                        <div class="desc" v-html="study.brief"></div>
                        <div
                            class="leturerBox"
                            v-if="study.trainerName.length > 0"
                        >
                            <img
                                class="leturer-logo"
                                src="~@/assets/leturer-logo.png"
                                alt=""
                            />
                            <span class="leturers">
                                <span
                                    v-for="trainer in study.trainerName"
                                    :key="trainer"
                                >
                                    {{ trainer }}
                                </span>
                            </span>
                        </div>
                        <div class="fenshiBox" v-if="study.studentNum">
                            <img
                                class="fenshi-logo"
                                src="~@/assets/fenshi-logo.png"
                                alt=""
                            />
                            <span class="num">{{ study.studentNum }}</span>
                        </div>
                        <div class="markBox" v-if="study.tagsName.length > 0">
                            <span
                                v-for="tag in study.tagsName"
                                :key="tag"
                                class="mark"
                            >
                                {{ tag }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dd">—— 到底了 ——</div>
        <img
            @click="goDataTemplate()"
            class="goDataTemplate"
            src="~@/assets/goDataTemplate.png"
            alt=""
        />
    </div>
</template>

<script>
    import indexService from "../../service/index.service";
    import userCenterServie from "../../service/user-center.service";
    import scrollerMixin from "../../scroller.mixin";
    import ganhuoService from "../../service/ganhuo.service";
    import userCenterService from "../../service/user-center.service";
    import { Toast } from "vant";
    import { Dialog } from "vant";

    export default {
        name: "index",
        mixins: [scrollerMixin],
        data() {
            return {
                search: "",
                ad: [],
                recentNew: [],
                zhuanqu: [],
                newLetterNum: 0,
                day: "",
                ganhuo: [],
                isMember: false,
            };
        },
        activated() {
            indexService.getCommentNotRead().then((res) => {
                let id = res.data.id;
                if (id) {
                    switch (res.data.type) {
                        case "COMMENT":
                            this.showCommentDialog(res);
                            break;
                        case "LETTER":
                            this.showLetterDialog(res, "您有新的站内信", () => {
                                this.$router.push(`/zanneixin-detail/${id}`);
                            });
                            break;
                        case "NEW_URSER_GIFT":
                            this.showLetterDialog(res, "新人专享福利", () => {
                                this.$router.push(`/user-center`);
                            });
                            break;
                        case "XUFEI":
                            this.showQianzanyanbaoPayDialog(res);
                            break;
                    }
                }
            });
            this.ifNewLetter();
        },
        mounted() {
            this.getToadyArticle();
            this.getAdStudy();
            this.ifNewLetter();
            this.getiIsMember();
        },
        methods: {
            showQianzanyanbaoPayDialog(res) {
                Dialog({
                    title: "",
                    className: "information",
                    confirmButtonText: "去续订",
                    closeOnClickOverlay: true,
                    message: `
                            <div class="title">
                                <span>续费提醒</span>
                            </div>
                            <div class="content">
                                <div>${res.data.content}</div>
                            </div>
                        `,
                }).then(() => {
                    this.$router.push(`/pay/STUDY?id=${res.data.id}`);
                });
            },
            showCommentDialog(res) {
                let id = res.data.id;
                Dialog({
                    title: "",
                    className: "information",
                    confirmButtonText: "去看看",
                    closeOnClickOverlay: true,
                    message: `
                            <div class="title">
                                <span>您的消息已被回复</span>
                            </div>
                            <div class="content">
                                <div class="js">您的消息：</div>

                                <div>${res.data.content}</div>
                            </div>
                        `,
                }).then(() => {
                    if (res.data.pass) {
                        location.href = `https://lianghua.nbd.com.cn/emotion3/comment#${id}`;
                    } else {
                        this.$router.push({
                            path: "/my-comment",
                            query: { id },
                        });
                    }
                });
            },
            showLetterDialog(res, title, cb) {
                Dialog({
                    title: "",
                    className: "information",
                    confirmButtonText: "去看看",
                    closeOnClickOverlay: true,
                    message: `
                            <div class="title">
                                <span>${title}</span>
                            </div>
                            <div class="content" >
                                <div>${res.data.content}</div>
                            </div>
                        `,
                }).then(() => {
                    cb && cb();
                });
            },
            goDataTemplate() {
                location.href =
                    "https://lianghua.nbd.com.cn/emotion3/data-dinner";
            },
            getiIsMember() {
                indexService.isMember().then((res) => {
                    this.isMember = res.data.isMember;
                });
            },
            ifNeedReNew() {
                userCenterService.ifNeedReNew().then((res) => {
                    if (res.data.needRenew) {
                        Toast(
                            `您的学员权限将在${res.data.expireTime}过期，请及时前往学员中心续费，以免影响正常使用`,
                        );
                    }
                });
            },
            getToadyArticle() {
                ganhuoService.getTodayArticle().then((res) => {
                    this.day = res.data.day;
                    this.ganhuo = res.data.list;
                });
            },
            getAdStudy() {
                indexService.getAdStudy().then((res) => {
                    this.ad = res.data.ad;
                    this.recentNew = res.data.recentNew;
                    this.zhuanqu = res.data.zhuanqu;
                });
            },
            ifNewLetter() {
                userCenterServie.ifNewLetter().then((res) => {
                    this.newLetterNum = res.data.count;
                });
            },
            adGo(link) {
                location.href = link;
            },
            goGanhuoDetail(id) {
                this.$router.push({ path: `/ganhuo-detail/${id}` });
            },
            go(study) {
                if (study.inLink) {
                    // this.$router.push(study.inLink);
                    location.href = study.inLink;
                    return;
                }
                if (study.closeDes) {
                    if (study.forStudent) {
                        if (this.isMember) {
                            this.$router.push(
                                `/video-course/NEWEST?courseId=${study.id}&courseType=STUDY`,
                            );
                        } else {
                            Dialog.confirm({
                                title: "",
                                message:
                                    "请先订购道达赢家学院VIP学员，\n解锁“道达科创10指数”权限",
                                confirmButtonText: "立即订购",
                            })
                                .then(() => {
                                    // on confirm
                                    this.$router.push(`/pay/STUDENT`);
                                })
                                .catch(() => {
                                    // on cancel
                                });
                        }
                    } else {
                        this.$router.push(
                            `/video-course/NEWEST?courseId=${study.id}&courseType=STUDY`,
                        );
                    }
                } else {
                    this.$router.push({
                        path: `/course-detail/${study.id}/${study.type}`,
                    });
                }
            },
            goZanneixinList() {
                this.$router.push({ path: "/zanneixin-list" });
            },
            goSearch() {
                this.$router.push({ path: "/search" });
            },
            goGanhuoList() {
                this.$router.push({ path: "/ganhuo-list" });
            },
        },
    };
</script>

<style lang="scss" scoped src="./index.scss"></style>
